// Entorno de pruebas propio (Linode). Archivo nuevo: no reemplaza ni modifica
// environment.ts (Dev, de la consultora) ni environment.prod.ts.
//
// Se usa con: ng build --configuration=qa
//
// Nota: apikey/apisecret viajan en el bundle y son visibles desde el navegador
// en cualquier entorno. Se reusan las del stage Dev, iguales a environment.ts,
// para no introducir credenciales nuevas.

export const environment = {
  production: true,

  // Auth server del entorno de pruebas. Tiene que coincidir exactamente con el
  // dominio de AUTH_DOMAIN en infra/qa/.env del repo puppis-auth, porque el
  // issuer del token se valida contra esta URL.
  authorityServerUrl: 'https://auth-qa.puppis.com.ar',

  // Stage Dev, igual que environment.ts: pruebas no le pega a Prod.
  singleCustomerUrl: 'https://9y3ipzft0f.execute-api.us-west-2.amazonaws.com/Dev',

  // La API de Vet (qa.puppis.inamika.com) no permite CORS desde micuenta-qa, asi
  // que en QA se accede por un proxy del propio nginx: /vet-api -> esa API. URL
  // relativa a proposito, para que cada dominio (.com.ar / .com.co) use su propio
  // origen y no haya CORS entre ellos. En prod NO se usa esto: environment.ts /
  // environment.prod.ts pegan directo a la API de Vet, que ya permite el origen
  // de produccion. Ver infra/qa/nginx (snippet vet-proxy.conf).
  vetServiceUrl: '/vet-api',

  // API de tiendas, para el combo "Mi tienda habitual" de Mis datos. Es una API
  // distinta de singleCustomerUrl, asi que el interceptor no le agrega las
  // credenciales: las manda StoresService explicitamente.
  storesUrl: 'https://ohebtr5hl6.execute-api.us-west-2.amazonaws.com/Dev/api/services/app/',

  apikey: 'MiCuenta',
  apisecret: '/HnngzGnsggS/FRl2y5FZqmKxyLlOplX2zwMsky4Y88='
};
